// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.box-shadow[data-v-f60f2948] {\r\n    border-bottom-color: #e9e9e9;\r\n    box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);\n}\n.sticky[data-v-f60f2948] {\r\n    /* background-color: rgb(48, 65, 86); */\r\n    background-color: #2d3a4b;\r\n    background-color: #24262f;\r\n    background-color: #f8f8f8;\r\n    /* text-align: right; 取消搜索栏靠右*/\r\n    line-height: 42px;\r\n    padding:0 10px;\n}\r\n", ""]);
// Exports
module.exports = exports;
